export enum ChartType {
    Bar,
    Line,
    Area
}
